export default __webpack_public_path__ + "static/media/img--legend.eebbef4d.png";